




import { Component, Vue } from "vue-property-decorator";
import { InvoiceCategoryCode } from "@/models/invoices";

@Component({
  components: {
    "invoices-category-total": () =>
      import("@/components/app/global/stats/invoicesCategoryTotal.vue")
  }
})
export default class InvoicesCategoryRecurrent extends Vue {
  // Getters
  public get attrs() {
    return this.$_.merge(
      {
        invoiceCategory: InvoiceCategoryCode.RECURRENT
      },
      this.$attrs
    );
  }
}
